import { SimpleSession } from "../app/app.interface";
import { AccessRestriction, RouteItem } from "../navigation/interfaces/navigation.interface";

export const authInterceptor = (
    routerConfig: RouteItem[],
    session?: SimpleSession
) => routerConfig.filter(route =>
    (route.accessRestriction === AccessRestriction.PUBLIC) ||
    (route.accessRestriction === AccessRestriction.PRIVATE && session?.auth_token) ||
    (session?.auth_token)
);